export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; adminOnly?: boolean }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'hemoculture-dashboard',
      displayName: 'menu.hemoculture-dashboard',
      meta: { icon: 'dashboard' },
    },
    {
      name: 'hemoculture-submissions-admin',
      displayName: 'menu.hemoculture-submissions-admin',
      meta: { icon: 'list_alt', adminOnly: true },
    },
    {
      name: 'hemoculture-submission',
      displayName: 'menu.hemoculture-submission',
      meta: { icon: 'mso-science' },
    },
    // {
    //   name: 'users',
    //   displayName: 'menu.users',
    //   meta: { icon: 'group', adminOnly: true },
    // },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: { icon: 'manage_accounts' },
    },
  ] as INavigationRoute[],
}
